// @flow
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Button } from '@finect/tabular-core/Button';
import { Search } from '@finect/tabular-icons/search';

import { CardBlock } from '../../../components';

// Banner de captación con la misma estética que las cards de asesor (mismo alto, radio y
// sombra) para que quede integrado en el listado y no como un bloque intrusivo. El borde
// izquierdo en color de marca lo distingue como llamada a la acción.
const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-height: 96px;
  margin: 0 auto;
  padding: 16px 20px;
  border-left: 4px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.boxShadow};
  background-color: #fff;
  color: ${({ theme }) => theme.colors.font};

  ${maxMediaQueries.phablet`
    flex-direction: column;
    align-items: flex-start;
  `};
`;

const IconWrap = styled.span`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primaryLL};
  color: ${({ theme }) => theme.colors.primary};

  ${maxMediaQueries.phablet`
    display: none;
  `};
`;

const Text = styled.div`
  flex: 1;
`;

const Title = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
`;

const Subtitle = styled.span`
  display: block;
  margin-top: 2px;
  font-size: 14px;
  line-height: 1.35;
  color: ${({ theme }) => theme.colors.fontL};
`;

type Props = {
  onClick: () => void
};

export const LeadBanner = ({ onClick }: Props) => (
  <CardBlock>
    <Banner>
      <IconWrap>
        <Search size="22" strokeWidth="2" />
      </IconWrap>
      <Text>
        <Title>¿No sabes qué asesor elegir?</Title>
        <Subtitle>Te ayudamos gratis a encontrar el asesor financiero que mejor encaja contigo.</Subtitle>
      </Text>
      <Button width="auto" onClick={onClick} data-fi-event="landingProvincia-encuentraAsesor">
        Encuentra tu asesor
      </Button>
    </Banner>
  </CardBlock>
);
